// Copyright (c) Docugami, Inc. All rights reserved.

import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const errorCounterSpanSeconds = 60 * 5;

export interface ErrorSliceState {
    networkErrorCount: number;
    lastNetworkError?: number;
}

export const errorSlice = createSlice({
    name: 'errors',
    initialState: {
        networkErrorCount: 0
    } as ErrorSliceState,
    reducers: {
        addNetworkError(state, action: PayloadAction<void>) {
            const now = dayjs();
            const lastError= !!state.lastNetworkError ? dayjs(state.lastNetworkError) : now;
            if (now.diff(lastError, 'seconds') > errorCounterSpanSeconds) {
                state.networkErrorCount = 0;
            }

            state.lastNetworkError = lastError.valueOf();
            state.networkErrorCount++;
        },
        resetNetworkErrors(state, action: PayloadAction<void>) {
            delete state.lastNetworkError;
            state.networkErrorCount = 0
        }
    }
});

export const { addNetworkError, resetNetworkErrors } = errorSlice.actions;